import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axiosClientDistribution from "../../../axiosClient/indexDistribution"
import { getQueryString } from "utilities/common"

// Boxes
export const createBox = createAsyncThunk(
  'distribution/createBox',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post("api/v1/admin/boxes/add", data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getBoxes = createAsyncThunk(
  'distribution/getBoxes',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/boxes/list?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getBoxDetails = createAsyncThunk(
  'distribution/getBoxDetails',
  async (data, { rejectWithValue }) => {
    try {
      const { boxId, ...rest } = data || {}
      const res = await axiosClientDistribution.get(`api/v1/admin/boxes/detail/${boxId}?${getQueryString(rest)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const deleteBox = createAsyncThunk(
  'distribution/deleteBox',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.delete(`api/v1/admin/boxes/delete/${id}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const updateBox = createAsyncThunk(
  'distribution/updateBox',
  async (data, { rejectWithValue }) => {
    try {
      const { _id, ...rest } = data || {}
      const res = await axiosClientDistribution.put(`api/v1/admin/boxes/update/${_id}`, rest)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

// unassigned products
export const getAllProducts = createAsyncThunk(
  'distribution/getAllProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/boxes/unassign/products?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const getUnassignedProducts = createAsyncThunk(
  'distribution/getUnassignedProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/boxes/unassigned/products?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const assignProduct = createAsyncThunk(
  'distribution/assignProduct',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/boxes/assign/products`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

// Distribution config
export const updateDistributionConfig = createAsyncThunk(
  'distribution/updateDistributionConfig',
  async (data, { rejectWithValue }) => {
    try {
      const { _id, ...rest } = data || {}
      const res = await axiosClientDistribution.post("api/v1/admin/distribution/add", { ...rest, id: _id })
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDistributionConfig = createAsyncThunk(
  'distribution/getDistributionConfig',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get("api/v1/admin/distribution/view")
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

// Aging rule
export const getAgingCategories = createAsyncThunk(
  'distribution/getAgingCategories',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get("api/v1/admin/aging/rules/get/category")
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const addAgingRule = createAsyncThunk(
  'distribution/addAgingRule',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post("api/v1/admin/aging/rules/add", data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const updateAgingRule = createAsyncThunk(
  'distribution/updateAgingRule',
  async (data, { rejectWithValue }) => {
    try {
      const { id, ...rest } = data || {}
      const res = await axiosClientDistribution.put(`api/v1/admin/aging/rules/update/${id}`, rest)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const agingRuleList = createAsyncThunk(
  'distribution/agingRuleList',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/aging/rules/list`)
      return res?.data || []
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const deleteAgingRule = createAsyncThunk(
  'distribution/deleteAgingRule',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.delete(`api/v1/admin/aging/rules/delete/${id}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

// Aging Products
export const getAgingBoxes = createAsyncThunk(
  'distribution/getAgingBoxes',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/aging/rules/boxes`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
// export const getAgingProducts = createAsyncThunk(
//   'distribution/getAgingProducts',
//   async (data, { rejectWithValue }) => {
//     try {
//       const res = await axiosClientDistribution.get(`api/v1/admin/aging/rules/products?${getQueryString(data)}`)
//       return res
//     } catch (error) {
//       return rejectWithValue(error?.response?.data)
//     }
//   }
// )
export const getAgingProducts = createAsyncThunk(
  'distribution/getAgingProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/aging/rules/box/products?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
// export const getPromotionProducts = createAsyncThunk(
//   'distribution/getPromotionProducts',
//   async (data, { rejectWithValue }) => {
//     try {
//       const res = await axiosClientDistribution.get(`api/v1/admin/aging/rules/promotion/products?${getQueryString(data)}`)
//       return res
//     } catch (error) {
//       return rejectWithValue(error?.response?.data)
//     }
//   }
// )
export const getPromotionProducts = createAsyncThunk(
  'distribution/getPromotionProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/aging/rules/box/promotions/products?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

// Template kit
export const addTemplateKit = createAsyncThunk(
  'distribution/addTemplateKit',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/template/add`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getTemplateKits = createAsyncThunk(
  'distribution/getTemplateKits',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/template/list?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const deleteTemplateKit = createAsyncThunk(
  'distribution/deleteTemplateKit',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.delete(`api/v1/admin/template/delete/${id}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getTemplateKitDetails = createAsyncThunk(
  'distribution/getTemplateKitDetails',
  async (data, { rejectWithValue }) => {
    try {
      const { templateId, ...rest } = data || {}
      const res = await axiosClientDistribution.get(`api/v1/admin/template/get/${templateId}?${getQueryString(rest)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const updateTemplateKit = createAsyncThunk(
  'distribution/updateTemplateKit',
  async (data, { rejectWithValue }) => {
    try {
      const { _id, ...rest } = data || {}
      const res = await axiosClientDistribution.put(`api/v1/admin/template/update/${_id}`, rest)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
// export const getCategoryProduct = createAsyncThunk(
//   'distribution/getCategoryProduct',
//   async (data, { rejectWithValue }) => {
//     try {
//       const res = await axiosClientDistribution.get(`api/v1/admin/template/product/sku?${getQueryString(data)}`)
//       return res;
//     } catch (error) {
//       return rejectWithValue(error?.response?.data)
//     }
//   }
// )
export const getCategoryProduct = createAsyncThunk(
  'distribution/getCategoryProduct',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/template/get/products?${getQueryString(data)}`)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
// export const getAssignedProducts = createAsyncThunk(
//   'distribution/getAssignedProducts',
//   async (data, { rejectWithValue }) => {
//     try {
//       const { templateId, ...rest } = data || {}
//       const res = await axiosClientDistribution.get(`api/v1/admin/template/product/sku/list/${templateId}?${getQueryString(rest)}`)
//       return res;
//     } catch (error) {
//       return rejectWithValue(error?.response?.data)
//     }
//   }
// )
export const getAssignedProducts = createAsyncThunk(
  'distribution/getAssignedProducts',
  async (data, { rejectWithValue }) => {
    try {
      const { templateId, ...rest } = data || {}
      const res = await axiosClientDistribution.get(`api/v1/admin/template/detail/product/sku/list/${templateId}?${getQueryString(rest)}`)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const updateAssignedProducts = createAsyncThunk(
  'distribution/updateAssignedProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.put(`api/v1/admin/template/product/sku`, data)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const addTemplateKitProducts = createAsyncThunk(
  'distribution/getTemplateKitDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/template/product/sku`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const deleteTemplateKitProducts = createAsyncThunk(
  'distribution/deleteTemplateKitProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post("api/v1/admin/template/product/sku/delete", data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getUnassignedRegions = createAsyncThunk(
  'distribution/getUnassignedRegions',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/template/get/unassigned/region?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

//  Brands
export const getAllBrands = createAsyncThunk(
  'distribution/getAllBrands',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/brands/list?${getQueryString(data)}`,)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

// Distribution management
export const getDistributionManagements = createAsyncThunk(
  'distribution/getDistributionManagements',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/list?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDistributionKitRegions = createAsyncThunk(
  'distribution/getDistributionKitRegions',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/get/region?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDistributionKitsBoxes = createAsyncThunk(
  'distribution/getDistributionKitsBoxes',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/get/boxes?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const deleteDistributionManagement = createAsyncThunk(
  'distribution/deleteDistributionManagement',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.delete(`api/v1/admin/manage-distributions/delete?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const freezeDistributionManagement = createAsyncThunk(
  'distribution/freezeDistributionManagement',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/manage-distributions/freeze`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
// export const getDistributionManagementProducts = createAsyncThunk(
//   'distribution/getDistributionManagementProducts',
//   async (data, { rejectWithValue }) => {
//     try {
//       const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/get/products?${getQueryString(data)}`)
//       return res
//     } catch (error) {
//       return rejectWithValue(error?.response?.data)
//     }
//   }
// )
export const getDistributionManagementProducts = createAsyncThunk(
  'distribution/getDistributionManagementProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/get/distributed/products?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getLowStockBoxes = createAsyncThunk(
  'distribution/getLowStockBoxes',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/low-stock/boxes?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
// export const getLowStockProducts = createAsyncThunk(
//   'distribution/getLowStockProducts',
//   async (data, { rejectWithValue }) => {
//     try {
//       const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/low-stock/products?${getQueryString(data)}`)
//       return res
//     } catch (error) {
//       return rejectWithValue(error?.response?.data)
//     }
//   }
// )
export const getLowStockProducts = createAsyncThunk(
  'distribution/getLowStockProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/low/stock/products?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
// export const getLowStockProducts = createAsyncThunk(
//   'distribution/getLowStockProducts',
//   async (data, { rejectWithValue }) => {
//     try {
//       const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/low-stock/products?${getQueryString(data)}`)
//       return res
//     } catch (error) {
//       return rejectWithValue(error?.response?.data)
//     }
//   }
// )
export const addDistributionRegion = createAsyncThunk(
  'distribution/addDistributionRegion',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post("api/v1/admin/manage-distributions/add/region", data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getPlannerOverrideNotes = createAsyncThunk(
  'distribution/getPlannerOverrideNotes',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/template/get/plannerNotes/${id}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const bulkDeleteDistributionProducts = createAsyncThunk(
  'distribution/bulkDeleteDistributionProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post("api/v1/admin/manage-distributions/bulk/delete", data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getUndistributedRegions = createAsyncThunk(
  'distribution/getUndistributedRegions',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/get/regions?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDistributionDrivers = createAsyncThunk(
  'distribution/getDistributionDrivers',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/fleets?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDistributionProducts = createAsyncThunk(
  'distribution/getDistributionProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/manage-distributions/box/products`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const addDistributionProduct = createAsyncThunk(
  'distribution/addDistributionProduct',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post("api/v1/admin/manage-distributions/add/product", data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const addDistributionManagement = createAsyncThunk(
  'distribution/addDistributionManagement',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/manage-distributions/cron `,)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const deleteRegion = createAsyncThunk(
  'distribution/deleteRegion',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.delete(`api/v1/admin/manage-distributions/delete/region?${getQueryString(data)}`,)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDistributionBoxes = createAsyncThunk(
  'distribution/getDistributionBoxes',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/get/freeze/distribution?distributionId=${id}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const freezeDistribution = createAsyncThunk(
  'distribution/freezeDistribution',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post("api/v1/admin/manage-distributions/freeze", data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const syncBlazeInventory = createAsyncThunk(
  'distribution/syncBlazeInventory',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post("api/v1/blaze/distribution/inventory", data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const updateDistributionProducts = createAsyncThunk(
  'distribution/updateDistributionProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post("api/v1/admin/manage-distributions/bulk/product/edit", data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDistributionManagementDetails = createAsyncThunk(
  'distribution/getDistributionManagementDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/detail?${getQueryString(data)}`)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const downloadBoxPDF = createAsyncThunk(
  'distribution/downloadBoxPDF',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/box/pdf?${getQueryString(data)}`)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const downloadDriverKitPDF = createAsyncThunk(
  'distribution/downloadDriverKitPDF',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/driver/kit/pdf?${getQueryString(data)}`)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const resetDistribution = createAsyncThunk(
  'distribution/resetDistribution',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/manage-distributions/reset?${getQueryString(data)}`)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

// Kit Refill Logs
export const getRefillListing = createAsyncThunk(
  'distribution/getRefillListing',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/kit-refill/list?${getQueryString(data)}`)
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getRefillProducts = createAsyncThunk(
  'distribution/getRefillProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/kit-refill/get/products?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getRefillRegions = createAsyncThunk(
  'distribution/getRefillRegions',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/kit-refill/get/regions?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const createRefillKit = createAsyncThunk(
  'distribution/createRefillKit',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/kit-refill/cron?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const refillLowStockProducts = createAsyncThunk(
  'distribution/refillLowStockProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/kit-refill/low/stock?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const testRefillKit = createAsyncThunk(
  'distribution/testRefillKit',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/kit-refill/use/qty`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
// export const deleteRefillList = createAsyncThunk(
//   'distribution/deleteRefillList',
//   async (data, { rejectWithValue }) => {
//     console.log("data",data);

//     try {
//       const res = await axiosClientDistribution.get(`api/v1/admin/kit-refill/delete?${data}`)
//       return res;
//     } catch (error) {
//       return rejectWithValue(error?.response?.data)
//     }
//   }
// )

export const deleteRefillList = createAsyncThunk(
  'distribution/deleteRefillList',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.delete(`api/v1/admin/kit-refill/delete/${id}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

// driver kit verification
export const getKitVerifications = createAsyncThunk(
  'distribution/getKitVerifications',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/driver-kit-verification/list?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDriverKit = createAsyncThunk(
  'distribution/getDriverKit',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/driver-kit-verification/view/kit?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDriverKitProducts = createAsyncThunk(
  'distribution/getDriverKitProducts',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/driver-kit-verification/driver/product/list?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getKitReport = createAsyncThunk(
  'distribution/getKitReport',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/driver-kit-verification/report?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const verifyKitReport = createAsyncThunk(
  'distribution/verifyKitReport',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/driver-kit-verification/dispatch`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const checkSafeInventory = createAsyncThunk(
  'distribution/checkSafeInventory',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/blaze/distribution/check/inventory`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const resetDriverKit = createAsyncThunk(
  'distribution/resetDriverKit',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/driver-kit-verification/reset?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const resetDriverKitProduct = createAsyncThunk(
  'distribution/resetDriverKitProduct',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/driver-kit-verification/reset/product`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const keepExtraDriverKitProduct = createAsyncThunk(
  'distribution/keepExtraDriverKitProduct',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/driver-kit-verification/keep`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const holdDriverKit = createAsyncThunk(
  'distribution/holdDriverKit',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/driver-kit-verification/onHold?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getProductDetails = createAsyncThunk(
  'distribution/getProductDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/driver-kit-verification/product/detail?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const addDiscrepancy = createAsyncThunk(
  'distribution/addDiscrepancy',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/driver-kit-verification/discrepancy`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDiscrepancy = createAsyncThunk(
  'distribution/getDiscrepancy',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/driver-kit-verification/discrepancy/${id}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const deleteDiscrepancy = createAsyncThunk(
  'distribution/deleteDiscrepancy',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.delete(`api/v1/admin/driver-kit-verification/discrepancy/${id}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const verifyPin = createAsyncThunk(
  'distribution/verifyPin',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/driver-kit-verification/pin/login`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const forgotPinCode = createAsyncThunk(
  'distribution/forgotPinCode',
  async (data = {}, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/driver-kit-verification/user/forgot/pin`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const updateDiscrepancy = createAsyncThunk(
  'distribution/updateDiscrepancy',
  async (data, { rejectWithValue }) => {
    try {
      const { discrepancyId, ...rest } = data || {}
      const res = await axiosClientDistribution.put(`api/v1/admin/driver-kit-verification/discrepancy/${discrepancyId}`, rest)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getProductScan = createAsyncThunk(
  'distribution/getProductScan',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/driver-kit-verification/scan/items`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

// Closure forms
export const getClosureForms = createAsyncThunk(
  'distribution/getClosureForms',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/closure-overview/list?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getRegionClosureForms = createAsyncThunk(
  'distribution/getRegionClosureForms',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/closure-overview/drivers?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getClosureFormsDetails = createAsyncThunk(
  'distribution/getClosureFormsDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/closure-overview/detail?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getConciliationDetails = createAsyncThunk(
  'distribution/getConciliationDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/closure-overview/revenue?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getClosureFormReport = createAsyncThunk(
  'distribution/viewClosureFormReport',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/closure-overview/report?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const approveClosureForm = createAsyncThunk(
  'distribution/approveClosureForm',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/closure-overview/approve`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const addClosureFormDiscrepancy = createAsyncThunk(
  'distribution/addClosureFormDiscrepancy',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post("api/v1/admin/closure-overview/discrepancy", data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const updateClosureFormDiscrepancy = createAsyncThunk(
  'distribution/updateClosureFormDiscrepancy',
  async (data, { rejectWithValue }) => {
    try {
      const { discrepancyId, ...rest } = data || {};
      const res = await axiosClientDistribution.put(`api/v1/admin/closure-overview/discrepancy/${discrepancyId}`, rest)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const deleteClosureFormDiscrepancy = createAsyncThunk(
  'distribution/deleteClosureFormDiscrepancy',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.delete(`api/v1/admin/closure-overview/discrepancy/${id}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const forceClosureForm = createAsyncThunk(
  'distribution/forceClosureForm',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/closure-overview/force/closure`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

// Discrepancy Management
export const getDiscrepancyList = createAsyncThunk(
  'distribution/getDiscrepancyList',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/discrepancy-management/list?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDiscrepancyDetails = createAsyncThunk(
  'distribution/getDiscrepancyDetails',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/discrepancy-management/${id}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDiscrepancyLogs = createAsyncThunk(
  'distribution/getDiscrepancyLogs',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/discrepancy-management/${id}/logs`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const addDiscrepancyComment = createAsyncThunk(
  'distribution/addDiscrepancyComment',
  async (data, { rejectWithValue }) => {
    try {
      const { id, ...rest } = data || {}
      const res = await axiosClientDistribution.post(`api/v1/admin/discrepancy-management/${id}/comment`, rest)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDiscrepancyApprovals = createAsyncThunk(
  'distribution/getDiscrepancyApprovals',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/discrepancy-management/approvals?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getDiscrepancyApprovalDetails = createAsyncThunk(
  'distribution/getDiscrepancyApprovalDetails',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/discrepancy-management/approvals/${id}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const updateDiscrepancyApprovalStatus = createAsyncThunk(
  'distribution/updateDiscrepancyApprovalStatus',
  async (data, { rejectWithValue }) => {
    try {
      const { id, ...rest } = data || {}
      const res = await axiosClientDistribution.put(`api/v1/admin/discrepancy-management/approvals/${id}/action`, rest)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const scanDiscrepancyProduct = createAsyncThunk(
  'distribution/scanDiscrepancyProduct',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.post(`api/v1/admin/discrepancy-management/scan/items`, data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getInventoryManagers = createAsyncThunk(
  'distribution/getInventoryManagers',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/discrepancy-management/inventory/managers?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const assignInventoryManager = createAsyncThunk(
  'distribution/assignInventoryManager',
  async (data, { rejectWithValue }) => {
    try {
      const { id, ...rest } = data || {}
      const res = await axiosClientDistribution.put(`api/v1/admin/discrepancy-management/${id}/status`, rest)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

// Waste inventory
export const getWasteInventory = createAsyncThunk(
  'distribution/getWasteInventory',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/waste-inventory/list?${getQueryString(data)}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
export const getWasteProductDetails = createAsyncThunk(
  'distribution/getWasteProductDetails',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosClientDistribution.get(`api/v1/admin/waste-inventory/get/${id}`)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

const inventoryDistribution = createSlice({
  name: ' inventoryDistribution',
  initialState: {
    isLoading: false,
    distributionConfig: {},
    agingRules: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDistributionConfig.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDistributionConfig.fulfilled, (state, action) => {
        state.isLoading = false;
        state.distributionConfig = action.payload;
      })
      .addCase(getDistributionConfig.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
    builder
      .addCase(agingRuleList.pending, (state) => {
      })
      .addCase(agingRuleList.fulfilled, (state, action) => {
        state.agingRules = action.payload;
      })
      .addCase(agingRuleList.rejected, (state, action) => {
      })
  }
})

export default inventoryDistribution.reducer;